import { defineStore } from 'pinia'
import { getUrlApiV1, findById, list, insert, remove, update } from '@/utils/index'

const PATH = '/users'

export const useUsersStore = defineStore('user', {
    state: () => ({
        user: {},
        items: [],
    }),

    getters: {
        me: (state) => state.user || {},
        all: (state) => state.items,
        count: (state) => state.items.length,
        getById: (state) => (id) => findById(state.items, id),
        getByIds: (state) => (ids = []) => state.items.filter((item) =>  ids.includes(item.id)).map((itemmap) => itemmap),
        getNameByIds: (state) => (ids = []) =>  state.items.filter((item) => ids.includes(item.id)).map((itemmap) => itemmap.name ),
        isAdmin: (state) => state.user?.level >= 2 ? true : false,
        isSuperAdmin: (state) => state.user?.level >= 3 ? true : false,
        getLevel: (state) => state.user?.level || 1,
        getPermissions: (state) => state.user?.permissions || [],
        getBusineAdmin: (state) => state.user?.busine_id || null,
        getMyBusine: (state) => state.user?.busine_id || null,
    },

    actions: {
        /**
         * search all users
         */
        async fetchItems(params = '') {
            const url =  getUrlApiV1() + PATH + params
            return list( this.$state, url )
        },
        /**
         * search one  users
         * @param {int} users
         */
        async fetchItem(id) {
            const url =  getUrlApiV1() + PATH
            return list( this.$state, url + '/' + id)
        },
        /**
         * Add new users
         * @param {object} users
         */
        async addItem(item) {
            const url =  getUrlApiV1() + PATH
            return insert( this.$state, url, item)
        },

        /**
         * edit users
         * @param {object, id} users
         */
        async editItem({ payload, id, method = 'post', param = '' }) {
            const url =  getUrlApiV1() + PATH
            return update( this.$state, url + '/' + id + param, payload, method)
        },
        /**
         * update photo user
         * @param {object, id} users
         */
        async updatePhoto({ payload, id, method = 'post', param = '' }) {
            const url =  getUrlApiV1() + PATH + '/file'
            return update( this.$state, url + '/' + id + param, payload, method)
        },

        updateUser(value) {
            if (value === null) return
            this.user = {
                ...this.user,
                ...value,
            }
        },
        /**
         * Remove item from the users
         * @param {int} id
         */
        async removeItem(id) {
            const url =  getUrlApiV1() + PATH
            return remove( this.$state, url, id)
        },
        
        // Métodos adicionais necessários para compatibilidade com o Vuex anterior
        getUsers(busine_id) {
            return this.fetchItems(`?busine_id=${busine_id}`)
        },
    },
})